export const distributors = {
  Albania: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Albania',
  },
  Andorra: {
    name: 'BREITLING IBERIA SLU',
    address: 'ANTONIO MAURA AVENUE, 12, 1ST, ',
    city: '07012 PALMA DE MALLORCA',
    phone: '+351 21 836 70 60',
    fax: '+351 21 831 01 01',
    displayName: 'Andorra',
  },
  Angola: {
    name: 'RJM DIFFUSION SA',
    address: 'AVENUE DE LA GARE 1 C/O LEXISS AVOCATS',
    city: '1003 LAUSANNE',
    phone: '',
    fax: '',
    displayName: 'Angola',
  },
  Antigua_Barbuda: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Antigua Barbuda',
  },
  Argentina: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Argentina',
  },
  Armenia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Armenia',
  },
  Aruba: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Aruba',
  },
  Australia: {
    name: 'BREITLING OCEANIA PTY LTD.',
    address: '61 MARKET STREET',
    city: 'NSW 2000 SYDNEY',
    phone: '+61 2 8224 0600',
    fax: '+61 2 8224 0601',
    displayName: 'Australia',
  },
  Austria: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Austria',
  },
  Azerbaijan: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Azerbaijan',
  },
  Bahamas: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Bahamas',
  },
  Bahrain: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Bahrain',
  },
  Barbados: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Barbados',
  },
  Belgium: {
    name: 'BREITLING BELUX - L.T.G. N.V.',
    address: 'CHAUSSEE DE LOUVAIN 531',
    city: '1380 LASNE',
    phone: '+32 2 351 44 40',
    fax: '+32 2 351 43 56',
    displayName: 'Belgium',
  },
  Belize: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Belize',
  },
  Bermuda: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Bermuda',
  },
  Bosnia_Herz: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Bosnia Herz',
  },
  Brasil: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Brasil',
  },
  British_Virgin_Islands: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'British Virgin Islands',
  },
  Brunei: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Brunei',
  },
  Bulgaria: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Bulgaria',
  },
  Canada: {
    name: 'BREITLING CANADA INC.',
    address: '250 BLOOR STREET EAST, SUITE 101',
    city: 'M4W 1E6 TORONTO',
    phone: '+1 416 546 8463',
    fax: '+1 416 546 8465',
    displayName: 'Canada',
  },
  Cayman_Islands: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Cayman Islands',
  },
  Chile: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Chile',
  },
  China: {
    name: 'SHANGHAI ORIGIN TRADE & DEVELOPMENT CO.',
    address: 'AEROSPACE BUILDING 7th FLOOR, 525 NORTH SICHUAN',
    city: 'SHANGHAI',
    phone: '+86 21 6352 2670',
    fax: '+86 21 6352 2667',
    displayName: 'China',
  },
  Colombia: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Colombia',
  },
  Congo: {
    name: 'RJM DIFFUSION SA',
    address: 'AVENUE DE LA GARE 1 C/O LEXISS AVOCATS',
    city: '1003 LAUSANNE',
    phone: '',
    fax: '',
    displayName: 'Congo',
  },
  Costa_Rica: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Costa Rica',
  },
  Croatia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Croatia',
  },
  Curacao: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Curacao',
  },
  Cyprus: {
    name: 'BREITLING HELLAS LTD.',
    address: '6, VOUKOURESTIOU STREET',
    city: '10564 ATHENS',
    phone: '+30 210 32 42 370',
    fax: '+30 210 36 22 977',
    displayName: 'Cyprus',
  },
  Czechia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Czechia',
  },
  Denmark: {
    name: 'BREITLING SCANDINAVIA AB',
    address: 'GRIBBYLUNDSVÄGEN 11-13',
    city: '187 62 TÄBY - SWEDEN',
    phone: '+46-8-54490770',
    fax: '',
    displayName: 'Denmark',
  },
  Dominica: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Dominica',
  },
  Dominican_Republic: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Dominican Republic',
  },
  Egypt: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Egypt',
  },
  Estonia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Estonia',
  },
  Fiji: {
    name: 'BREITLING OCEANIA PTY LTD.',
    address: '61 MARKET STREET',
    city: 'NSW 2000 SYDNEY',
    phone: '+61 2 8224 0600',
    fax: '+61 2 8224 0601',
    displayName: 'Fiji',
  },
  Finland: {
    name: 'BREITLING SCANDINAVIA AB',
    address: 'GRIBBYLUNDSVÄGEN 11-13',
    city: '187 62 TÄBY - SWEDEN',
    phone: '+46-8-54490770',
    fax: '',
    displayName: 'Finland',
  },
  France: {
    name: 'BREITLING FRANCE S.A.R.L.',
    address: 'LE SHACK, 4, IMPASSE SANDRIE',
    city: '75009 PARIS',
    phone: '+33-1-56436700',
    fax: '',
    displayName: 'France',
  },
  Georgia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Georgia',
  },
  Germany: {
    name: 'BREITLING DEUTSCHLAND GMBH',
    address: 'NEUREUTER STRAßE 37A',
    city: '76185 KARLSRUHE',
    phone: '+49-721-984830',
    fax: '+49-721-9848341',
    displayName: 'Germany',
  },
  Greece: {
    name: 'BREITLING HELLAS LTD.',
    address: '6, VOUKOURESTIOU STREET',
    city: '10564 ATHENS',
    phone: '+30 210 32 42 370',
    fax: '+30 210 36 22 977',
    displayName: 'Greece',
  },
  Guatemala: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Guatemala',
  },
  Honduras: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Honduras',
  },
  Hong_Kong: {
    name: 'BREITLING CHINA LIMITED',
    address: '519-521 HENNESSY ROAD, 2/F-4/F, BREITLING TOWER',
    city: 'CAUSEWAY BAY',
    phone: '+852 2376 0909',
    fax: '+852 2376 1006',
    displayName: 'Hong Kong',
  },
  Hungary: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Hungary',
  },
  India: {
    name: 'BREITLING INDIA PVT LTD',
    address:
      'UNIT 5, 3ND FLOOR, BRADY GLADYS PLAZA, 1/447 SENAPATI BAPAT MARG, LOWER PAREL',
    city: '400013 MUMBAI',
    phone: '+91 22 6615 1000',
    fax: '',
    displayName: 'India',
  },
  Indonesia: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Indonesia',
  },
  Ireland: {
    name: 'BREITLING UK LTD.',
    address: '198 REGENT STREET',
    city: 'W1B 5TP LONDON',
    phone: '+44 20 7518 7010',
    fax: '+44 20 7493 5339',
    displayName: 'Ireland',
  },
  Israel: {
    name: 'PADANI JEWELLERS LTD',
    address: '6 KOIFMAN STREET',
    city: '68012 TEL AVIV',
    phone: '+972 3 517 73 33',
    fax: '+972 3 516 56 50',
    displayName: 'Israel',
  },
  Italy: {
    name: 'BREITLING ITALIA SRL',
    address: 'VIA DELLA MOSCOVA 3',
    city: '20121 MILANO',
    phone: '+39 02 00 69 10 10',
    fax: '+39 02 00 69 10 60',
    displayName: 'Italy',
  },
  Jamaica: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Jamaica',
  },
  Japan: {
    name: 'BREITLING JAPAN LTD (MAIN OFFICE) / ブライトリング・ジャパン株式会社',
    address:
      'SHIBAKOEN BLDG., 2-2-22 SHIBAKOEN, MINATO-KU / 港区芝公園2-2-22 芝公園ビル',
    city: '105-0011 TOKYO / 東京都',
    phone: '+81-3-34360011',
    fax: '+81-3-34360012',
    displayName: 'Japan',
  },
  Jordan: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Jordan',
  },
  Kazakhstan: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Kazakhstan',
  },
  Kenia: {
    name: 'RJM DIFFUSION SA',
    address: 'AVENUE DE LA GARE 1 C/O LEXISS AVOCATS',
    city: '1003 LAUSANNE',
    phone: '',
    fax: '',
    displayName: 'Kenia',
  },
  Kosovo: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Kosovo',
  },
  Kuwait: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Kuwait',
  },
  Laos: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Laos',
  },
  Latvia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Latvia',
  },
  Lebanon: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Lebanon',
  },
  Liechtenstein: {
    name: 'BREITLING SWITZERLAND AG',
    address: 'BAHNHOFSTRASSE 39',
    city: '2540 GRENCHEN',
    phone: '+41 32 654 54 54',
    fax: '+41 32 654 54 00',
    displayName: 'Liechtenstein',
  },
  Lithuania: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Lithuania',
  },
  Luxembourg: {
    name: 'BREITLING BELUX - L.T.G. N.V.',
    address: 'CHAUSSEE DE LOUVAIN 531',
    city: '1380 LASNE',
    phone: '+32 2 351 44 40',
    fax: '+32 2 351 43 56',
    displayName: 'Luxembourg',
  },
  Macao: {
    name: 'BREITLING CHINA LIMITED',
    address: '519-521 HENNESSY ROAD, 2/F-4/F, BREITLING TOWER, CAUSEWAY BAY',
    city: 'HONG KONG',
    phone: '+852 2376 0909',
    fax: '+852 2376 1006',
    displayName: 'Macao',
  },
  Macedonia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Macedonia',
  },
  Madagascar: {
    name: 'RJM DIFFUSION SA',
    address: 'AVENUE DE LA GARE 1 C/O LEXISS AVOCATS',
    city: '1003 LAUSANNE',
    phone: '',
    fax: '',
    displayName: 'Madagascar',
  },
  Malaysia: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Malaysia',
  },
  Maldives: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Maldives',
  },
  Malta: {
    name: 'BREITLING ITALIA SRL',
    address: 'VIA DELLA MOSCOVA 3',
    city: '20121 MILANO',
    phone: '+39 2 0069 1010',
    fax: '',
    displayName: 'Malta',
  },
  Mauritius_Island: {
    name: 'PEXIM LTD',
    address: '2 RUE JULES KOENIG',
    city: '11318 PORT LOUIS',
    phone: '+230 212 62 05',
    fax: '+230 208 88 50',
    displayName: 'Mauritius Island',
  },
  Mexico: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Mexico',
  },
  Mexico_Cozumel: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Mexico Cozumel',
  },
  Mexico_Playa_del_Carmen: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Mexico Playa del Carmen',
  },
  Montenegro: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Montenegro',
  },
  Morocco: {
    name: 'RJM DIFFUSION SA',
    address: 'AVENUE DE LA GARE 1 C/O LEXISS AVOCATS',
    city: '1003 LAUSANNE',
    phone: '',
    fax: '',
    displayName: 'Morocco',
  },
  Myanmar: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Myanmar',
  },
  Nassau: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Nassau',
  },
  Nepal: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Nepal',
  },
  Netherlands: {
    name: 'Breitling Netherlands BV',
    address: 'NEW YORKSTRAAT 44',
    city: '1175 RD LIJNDEN',
    phone: '+31 20-6596453',
    fax: '+31 20-6595520',
    displayName: 'Netherlands',
  },
  New_Caledonia: {
    name: 'BIJOUTERIE GASPARD',
    address: '39 RUE DE SÉBASTOPOL B.P. 625',
    city: '98845 NOUMÉA CEDEX',
    phone: '+687 27 16 30',
    fax: '+687 28 38 17',
    displayName: 'New Caledonia',
  },
  New_Zealand: {
    name: 'BREITLING OCEANIA PTY LTD.',
    address: '61 MARKET STREET',
    city: 'NSW 2000 SYDNEY',
    phone: '+61 2 8224 0600',
    fax: '+61 2 8224 0601',
    displayName: 'New Zealand',
  },
  Norway: {
    name: 'BREITLING SCANDINAVIA AB',
    address: 'GRIBBYLUNDSVÄGEN 11-13',
    city: '187 62 TÄBY - SWEDEN',
    phone: '+46-8-54490770',
    fax: '',
    displayName: 'Norway',
  },
  Oman: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Oman',
  },
  Panama: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Panama',
  },
  Paraguay: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Paraguay',
  },
  Peru: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Peru',
  },
  Philippines: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Philippines',
  },
  Poland: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Poland',
  },
  Portugal: {
    name: 'BREITLING IBERIA SLU',
    address: 'ANTONIO MAURA AVENUE, 12, 1ST',
    city: '07012 PALMA DE MALLORCA',
    phone: '+351 21 836 70 60',
    fax: '+351 21 831 01 01',
    displayName: 'Portugal',
  },
  Puerto_Rico: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Puerto Rico',
  },
  Qatar: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Qatar',
  },
  Réunion: {
    name: 'ATELIER GERARD',
    address: '30, RUE PASTEUR',
    city: '97400 SAINT-DENIS-DE-LA-REUNION',
    phone: '+262-262-212652',
    fax: '+262-262-415195',
    displayName: 'Réunion',
  },
  Romania: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Romania',
  },
  Sanya: {
    name: 'BREITLING CHINA LIMITED',
    address: '519-521 HENNESSY ROAD, 2/F-4/F, BREITLING TOWER, CAUSEWAY BAY',
    city: 'HONG KONG',
    phone: '+852 2376 0909',
    fax: '+852 2376 1006',
    displayName: 'Sanya',
  },
  Saudi_Arabia: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'Saudi Arabia',
  },
  Serbia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Serbia',
  },
  Singapore: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Singapore',
  },
  Singapore_DFS: {
    name: 'DFS VENTURE (SINGAPORE) PTE LTD',
    address: 'CHANGI AIRPORT TERMINAL 2, 026-90 DEPARTURE NORTH',
    city: '918156 SINGAPORE',
    phone: '+65 6891 9168',
    fax: '',
    displayName: 'Singapore DFS',
  },
  Sint_Maarten: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Sint Maarten',
  },
  Slovakia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Slovakia',
  },
  Slovenia: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Slovenia',
  },
  South_Africa: {
    name: 'JABREE CC',
    address: '86 LONGSHIPS DRIVE',
    city: '6600 PLETTENBERG BAY',
    phone: '+27 11 326 2923',
    fax: '',
    displayName: 'South Africa',
  },
  South_Korea: {
    name: 'BREITLING KOREA',
    address: '4F, 35, JANGMUN-RO, YOUNGSAN-GU, 서울특별시 용산구 장문로 35',
    city: '04392 SEOUL',
    phone: '+82 2 3279 9000',
    fax: '+82 2 3279 9001',
    displayName: 'South Korea',
  },
  Spain: {
    name: 'BREITLING IBERIA SLU',
    address: 'ANTONIO MAURA AVENUE, 12, 1ST',
    city: '07012 PALMA DE MALLORCA',
    phone: '+351 21 836 70 60',
    fax: '+351 21 831 01 01',
    displayName: 'Spain',
  },
  Sri_Lanka: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Sri Lanka',
  },
  St_Barthélemy: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'St_Barthélemy',
  },
  St_Barts: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'St_Barts',
  },
  St_Kitts_Nevis: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'St Kitts Nevis',
  },
  St_Lucia: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'St Lucia',
  },
  St_Martin: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'St Martin',
  },
  St_Thomas: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'St Thomas',
  },
  Sweden: {
    name: 'BREITLING SCANDINAVIA AB',
    address: 'GRIBBYLUNDSVÄGEN 11-13',
    city: '187 62 TÄBY - SWEDEN',
    phone: '+46-8-54490770',
    fax: '',
    displayName: 'Sweden',
  },
  Switzerland: {
    name: 'BREITLING SWITZERLAND AG',
    address: 'BAHNHOFSTRASSE 39',
    city: '2540 GRENCHEN',
    phone: '+41 32 654 54 54',
    fax: '+41 32 654 54 00',
    displayName: 'Switzerland',
  },
  Taiwan: {
    name: 'BREITLING CHINA LIMITED',
    address: '519-521 HENNESSY ROAD, 2/F-4/F, BREITLING TOWER, CAUSEWAY BAY',
    city: 'HONG KONG',
    phone: '+852 2376 0909',
    fax: '+852 2376 1006',
    displayName: 'Taiwan',
  },
  Thailand: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Thailand',
  },
  Totola: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Thailand',
  },
  Tunis: {
    name: 'RJM DIFFUSION SA',
    address: 'AVENUE DE LA GARE 1 C/O LEXISS AVOCATS',
    city: '1003 LAUSANNE',
    phone: '',
    fax: '',
    displayName: 'Tunis',
  },
  Türkiye: {
    name: 'DOGUS PERAKENDE SATIS GIYIM VE AKSESUAR',
    address: 'D OFIS MASLAK MAH. BÜYÜKDERE CAD No:249',
    city: '34485 SARIYER/ISTANBUL-TÜRKIYE',
    phone: '+90 212 354 1414',
    fax: '',
    displayName: 'Türkiye',
  },
  Turks_Caicos_Islands: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Turks Caicos Islands',
  },
  US_Virgin_Islands: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'US Virgin Islands',
  },
  UAE: {
    name: 'BREITLING MIDDLE EAST LLC',
    address: 'CAPRICORN TOWER, OFFICE 801, 8TH FLOOR, SHEIKH ZAYED ROAD',
    city: 'DUBAI',
    phone: '+971 142323061',
    fax: '',
    displayName: 'UAE',
  },
  Ukraine: {
    name: 'BREITLING AUSTRIA',
    address: 'STELLA KLEIN LÖW WEG 11-17, HOUSE C, TOP 3.2.',
    city: 'A-1020 WIEN',
    phone: '+43 1 374 98 00',
    fax: '',
    displayName: 'Ukraine',
  },
  United_Kingdom: {
    name: 'BREITLING UK LTD.',
    address: '198 REGENT STREET',
    city: 'W1B 5TP LONDON',
    phone: '+44 20 7518 7010',
    fax: '+44 20 7493 5339',
    displayName: 'United Kingdom',
  },
  United_States: {
    name: 'BREITLING USA INC.',
    address: 'HANGAR 7, 206 DANBURY ROAD',
    city: 'WILTON, CT 06897',
    phone: '877-BREITLING',
    fax: '+1 203 762-1178',
    displayName: 'United States',
  },
  Uruguay: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Uruguay',
  },
  Venezuela: {
    name: 'BREITLING LATAM INC.',
    address: '999 BRICKELL AVE, SUITE 1000',
    city: '33131 MIAMI',
    phone: '+1 242 352 78 35',
    fax: '+1 242 352 41 65',
    displayName: 'Venezuela',
  },
  Vietnam: {
    name: 'BREITLING SOUTH EAST ASIA PTE LTD',
    address: '11 BISHAN STREET 21, #03-03B BOSCH BUILDING',
    city: '573943 SINGAPORE',
    phone: '+65-67326347',
    fax: '',
    displayName: 'Vietnam',
  },
};
